import { FC, memo } from "react";
/**
 * Eye Icon Props Interface
 * @interface StarProps
 */
interface SortProps {
  color?: string;
}
const SortAscending: FC<SortProps> = ({ color = "#E0E0E0" }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 6L10 6V8L14 8L14 6ZM21 18V16L3 16V18L21 18ZM18 11L6 11V13L18 13V11Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default memo(SortAscending);
